import type { MessageKey } from './en';

// Latin American neutral Spanish, addressed with "usted" (owner rule).
// Typed as Record<MessageKey, string>: a missing key fails `npm run typecheck`.
export const es: Record<MessageKey, string> = {
  appName: 'EAT Photo Booth',
  openFolder: 'Abrir carpeta',
  recent: 'Recientes',
  recentFolders: 'Carpetas recientes',
  noFolder: 'Ninguna carpeta abierta',
  photoCount: '{n} fotos',
  export: 'Exportar',
  help: 'Ayuda',
  language: 'Idioma',
  history: 'Historial',
  presets: 'Ajustes guardados',
  filmstripEmpty: 'Abra una carpeta de fotos JPG, PNG, WebP, HEIC o TIFF para empezar.',
  viewerEmpty: 'Ninguna foto seleccionada',
  viewerOpen: 'Abrir foto',
  autoFix: 'Corrección automática',
  panelLight: 'Luz',
  panelWhiteBalance: 'Balance de blancos',
  panelColor: 'Color',
  panelHsl: 'HSL',
  panelCurve: 'Curva de tonos',
  panelDetail: 'Detalle',
  panelGeometry: 'Geometría',
  panelBackground: 'Fondo',
  panelMasks: 'Máscaras',
  panelHeal: 'Corrector',
  panelSkin: 'Piel',
  panelCleanWhites: 'Blancos limpios',
  panelFood: 'Estilos de comida',
  panelPresets: 'Ajustes guardados',
  collapse: 'Contraer',
  expand: 'Expandir',
  unsupportedTitle: 'Este navegador no es compatible',
  unsupportedBody: 'Use Chrome o Edge en una computadora portátil o de escritorio.',
  unsupportedMissing: 'Falta: {list}',
  close: 'Cerrar',
  updateReady: 'Hay una versión nueva de la aplicación.',
  isolationReady: 'Reinicie la aplicación para terminar de instalarla (quitar fondos será más rápido).',
  reloadNow: 'Recargar ahora',
  exposure: 'Exposición',
  contrast: 'Contraste',
  highlights: 'Altas luces',
  shadows: 'Sombras',
  whites: 'Blancos',
  blacks: 'Negros',
  temp: 'Temperatura',
  tint: 'Matiz',
  eyedropper: 'Elegir neutro',
  eyedropperHint: 'Haga clic en un área gris o blanca neutra',
  angle: 'Ángulo',
  aspect: 'Proporción',
  aspectFree: 'Libre',
  aspectOriginal: 'Original',
  aspectIgSquare: 'Instagram cuadrado 1:1',
  aspectIgPortrait: 'Instagram vertical 4:5',
  aspectStory: 'Historia 9:16',
  aspectDish: 'Tarjeta de plato 1:1',
  constrain: 'Restringir recorte',
  cropTool: 'Recortar y enderezar',
  straighten: 'Enderezar',
  straightenHint: 'Dibuje una línea sobre el horizonte o un borde vertical',
  done: 'Listo',
  amount: 'Cantidad',
  reset: 'Restablecer',
  zoomFit: 'Ajustar',
  zoom100: '100 %',
  before: 'Antes',
  after: 'Después',
  split: 'Vista dividida',
  clipping: 'Recorte de luces y sombras',
  undo: 'Deshacer',
  redo: 'Rehacer',
  histogram: 'Histograma',
  zoomNote: 'Haga zoom al 100 % para evaluar nitidez y ruido',
  openFiles: 'Abrir fotos',
  decoding: 'Abriendo…',
  decodeFailed: 'No se pudo abrir {name}: {reason}',
  doubleClickReset: 'Doble clic para restablecer',
  exportTitle: 'Exportar foto',
  format: 'Formato',
  quality: 'Calidad',
  bitDepth: 'Profundidad de bits',
  colorSpace: 'Espacio de color',
  size: 'Tamaño',
  sizeOriginal: 'Tamaño original',
  sizeLongEdge: 'Lado largo (px)',
  dpi: 'Resolución (ppp)',
  outputSharpen: 'Nitidez de salida',
  sharpenNone: 'Ninguna',
  sharpenScreen: 'Pantalla',
  sharpenMatte: 'Papel mate',
  sharpenGlossy: 'Papel brillante',
  amountLow: 'Baja',
  amountStandard: 'Estándar',
  amountHigh: 'Alta',
  metadata: 'Metadatos',
  metaKeepAll: 'Conservar todo',
  metaStripGps: 'Quitar ubicación',
  metaCopyrightOnly: 'Solo derechos de autor',
  metaStripAll: 'Quitar todo',
  jpegFlattenNote:
    'JPEG no admite transparencia: las áreas transparentes se rellenan con el color de relleno (blanco por defecto).',
  exportNow: 'Exportar',
  cancel: 'Cancelar',
  exporting: 'Exportando…',
  exportDone: 'Guardado {name} ({w}×{h}, {ms} ms)',
  exportFailed: 'La exportación falló: {reason}',
  recentEmpty: 'No hay carpetas recientes',
  fallbackBanner: 'Su navegador no puede guardar junto a sus fotos. Las exportaciones se descargan como zip.',
  dropFolder: 'Suelte una carpeta para abrirla',
  filter: 'Filtro',
  filterAll: 'Todas',
  filterPicks: 'Elegidas',
  filterRejected: 'Rechazadas',
  filterEdited: 'Editadas',
  filterStars: '★ {n} o más',
  rating: 'Calificación',
  stars: '{n} estrellas',
  rejected: 'Rechazada',
  edited: 'Editada',
  bgRemoved: 'Fondo quitado',
  sidecarMismatch: 'El archivo de ajustes pertenece a otra versión de esta foto y se ignoró',
  sidecarLocked:
    'El archivo de ajustes lo creó una versión más nueva de esta aplicación, o no se pudo leer. Se conserva tal cual: los cambios en esta foto no se guardan.',
  cullView: 'Vista de selección',
  exitCull: 'Salir de la vista de selección',
  autoAdvance: 'Avanzar automáticamente',
  selectedCount: '{n} seleccionadas',
  permissionNeeded: 'Permita el acceso a «{name}» para abrirla',
  groupCrop: 'Recorte y enderezado',
  groupPerspective: 'Perspectiva',
  groupLut: 'Perfil LUT',
  syncTitle: 'Elija qué copiar',
  copySettings: 'Copiar ajustes',
  pasteSettings: 'Pegar ajustes',
  pastedN: 'Pegado en {n} fotos',
  undoPasteN: 'Deshacer pegar en {n} fotos',
  copied: 'Ajustes copiados',
  webpAnimated: 'WebP animado: solo se abrió el primer cuadro.',
  ok: 'Aceptar',
  selectAllGroups: 'Todos',
  selectNoGroups: 'Ninguno',
  matchedN: 'Exposición igualada en {n} fotos',
  matchExposure: 'Igualar exposición',
  matchExposureHint: 'La foto activa sirve de referencia para las demás fotos seleccionadas',
  autoFixDone: 'Corrección automática aplicada',
  savePreset: 'Guardar el estilo actual',
  presetName: 'Nombre del ajuste',
  applyPreset: 'Aplicar a las seleccionadas',
  importPreset: 'Importar…',
  exportPresetFile: 'Exportar archivo',
  deletePreset: 'Eliminar',
  noPresets: 'Aún no hay ajustes guardados',
  presetImportFailed: 'No se pudo importar: {reason}',
  presetApplied: 'Ajuste aplicado a {n} fotos',
  builtIn: 'Incluido',
  exportPresets: 'Ajustes de exportación',
  scope: 'Fotos',
  scopeSelected: 'Seleccionadas ({n})',
  scopePicks: 'Todas las elegidas ({n})',
  scopeAll: 'Todas ({n})',
  destination: 'Destino',
  destFolder: 'carpeta exports junto a las fotos',
  destZip: 'Archivo zip',
  rename: 'Renombrar',
  renameTemplate: 'Plantilla de nombre',
  renameTokens: 'Variables: {client} {event} {seq:3} {orig} {date} {menu} {preset}',
  client: 'Cliente',
  event: 'Evento',
  dishNames: 'Menú (un plato por línea)',
  dishPreview: 'Nombres en el orden de la tira',
  watermark: 'Marca de agua',
  wmText: 'Texto',
  wmLogo: 'Logotipo (PNG)',
  wmChooseLogo: 'Elegir logotipo…',
  wmSize: 'Tamaño (% del lado corto)',
  wmOpacity: 'Opacidad',
  wmPosition: 'Posición',
  wmMargin: 'Margen (%)',
  wmColor: 'Color',
  metadataOverride: 'Metadatos',
  metaFromPreset: 'Según cada ajuste',
  specNote: 'Verifique la especificación actual de la app',
  progress: '{done} de {total}',
  eta: 'faltan unos {s} s',
  cancelling: 'Cancelando después de este archivo…',
  batchDone: 'Se exportaron {n} archivos en {s} s',
  batchCancelled: 'Cancelado: se exportaron {n} archivos',
  batchFailures: '{n} fallaron:',
  noPresetChosen: 'Elija al menos un ajuste de exportación',
  duplicate: 'Duplicar',
  posTL: 'Arriba a la izquierda',
  posTC: 'Arriba al centro',
  posTR: 'Arriba a la derecha',
  posML: 'Centro a la izquierda',
  posC: 'Centro',
  posMR: 'Centro a la derecha',
  posBL: 'Abajo a la izquierda',
  posBC: 'Abajo al centro',
  posBR: 'Abajo a la derecha',
  // M7 colour and detail panels
  vibrance: 'Intensidad',
  saturation: 'Saturación',
  hslHue: 'Tono',
  hslSat: 'Saturación',
  hslLum: 'Luminancia',
  bandRed: 'Rojo',
  bandOrange: 'Naranja',
  bandYellow: 'Amarillo',
  bandGreen: 'Verde',
  bandAqua: 'Aguamarina',
  bandBlue: 'Azul',
  bandPurple: 'Morado',
  bandMagenta: 'Magenta',
  curveMaster: 'RGB',
  curveR: 'Rojo',
  curveG: 'Verde',
  curveB: 'Azul',
  curveHint:
    'Haga clic para agregar un punto, arrástrelo para moverlo y haga doble clic en un punto para quitarlo',
  curveReset: 'Restablecer curva',
  sharpAmount: 'Nitidez',
  sharpRadius: 'Radio',
  sharpMasking: 'Máscara',
  nrLuma: 'Reducción de ruido',
  nrColor: 'Ruido de color',
  // M8 local tools
  addLinear: 'Lineal',
  addRadial: 'Radial',
  addBrush: 'Pincel',
  addMaskHint: 'Agregar una máscara:',
  maskLinear: 'Máscara lineal {n}',
  maskRadial: 'Máscara radial {n}',
  maskBrush: 'Máscara de pincel {n}',
  maskInvert: 'Invertir',
  maskDelete: 'Eliminar máscara',
  maskOverlay: 'Mostrar la máscara (O)',
  maskLimit: 'Hasta 8 máscaras por foto',
  maskEdit: 'Editar en la foto',
  maskHintLinear: 'Arrastre sobre la foto para dibujar el degradado; arrastre los puntos para ajustarlo',
  maskHintRadial:
    'Arrastre sobre la foto para dibujar una elipse; arrastre los puntos para cambiar su tamaño o girarla',
  maskHintBrush: 'Pinte sobre la foto; mantenga Alt para borrar',
  maskFeather: 'Difuminado',
  addColour: 'Color',
  addObject: 'Objeto',
  maskColour: 'Máscara de color {n}',
  maskObject: 'Máscara de objeto {n}',
  maskHintColour: 'Toque el ingrediente en la foto para elegir su color. Mayús+toque agrega otro color.',
  maskHintObject:
    'Toque el objeto para seleccionarlo. Toque otra vez para agregar más; Alt+toque marca una parte que no es del objeto.',
  pickModePick: 'Elegir',
  pickModeIn: 'Pintar',
  pickModeOut: 'Borrar',
  pickModeLimit: 'Limitar',
  colourPresets: 'Selección rápida:',
  presetTomato: 'Tomate',
  presetGreens: 'Lechuga / hierbas',
  presetCheese: 'Queso',
  presetMeat: 'Carne',
  presetBread: 'Pan',
  colourRange: 'Rango',
  colourSoftness: 'Suavidad',
  colourPicked: '{n} colores elegidos',
  colourClear: 'Borrar colores',
  objectEdge: 'Refinar bordes',
  objectPoints: '{n} puntos',
  objectClear: 'Borrar puntos',
  objectRunning: 'Buscando el objeto…',
  objectFirst: 'El primer toque en una foto tarda unos segundos; los siguientes son rápidos.',
  objectMissing:
    'El modelo de objetos no está instalado en este servidor; la selección de objetos no está disponible.',
  objectError: 'No se pudo encontrar el objeto: {reason}',
  maskLimit2: 'Limitar a un área:',
  limitNone: 'Toda la foto',
  limitLinear: 'Lineal',
  limitRadial: 'Radial',
  maskHintLimit: 'Arrastre sobre la foto para colocar el área; arrastre los controles para cambiarla.',
  clarity: 'Claridad',
  brushSize: 'Tamaño del pincel',
  brushFeather: 'Difuminado del pincel',
  brushFlow: 'Flujo',
  healTool: 'Pincel corrector / clonar',
  healModeHeal: 'Corregir',
  healModeClone: 'Clonar',
  healHint:
    'Pinte sobre una mancha. Primero haga Alt-clic para elegir el origen; arrastre los círculos para mover una corrección o su origen',
  healCount: '{n} correcciones',
  healClear: 'Quitar todas las correcciones',
  healUndoLast: 'Quitar la última corrección',
  opacity: 'Opacidad',
  skinTool: 'Pincel de piel',
  skinHint: 'Pinte sobre la piel para suavizar manchas; la textura se conserva. Alt borra',
  skinClear: 'Borrar los trazos de piel',
  cleanWhitesWhole: 'Toda la foto',
  cleanWhitesBrush: 'Solo donde se pinte',
  cleanWhitesHint: 'Aclara y neutraliza platos y fondos casi blancos; los colores de la comida no cambian',
  cleanWhitesTool: 'Pintar zonas',
  // M9 background removal
  bgRemove: 'Quitar fondo',
  bgRemoveN: 'Quitar fondo en {n} seleccionadas',
  bgOff: 'No',
  bgAuto: 'Automático',
  bgKey: 'Recortar por color',
  bgModel: 'Modelo',
  bgModelAuto: 'Rápido (recomendado)',
  bgModelIsnet: 'IS-Net: bordes más nítidos, más lento',
  bgLoading: 'Cargando el modelo de fondo…',
  bgRunning: 'Buscando el sujeto…',
  bgModelError:
    'No se pudo cargar el modelo de fondo. El modo por color y el pincel de ajuste siguen funcionando.',
  bgDone: 'Listo con {model} ({ep}) en {s} s',
  bgKeyPick: 'Elegir el color del fondo',
  bgKeyColor: 'Color del fondo',
  bgKeyHint: 'Haga clic en el fondo de la foto para elegir su color',
  bgTolerance: 'Tolerancia',
  bgSoftness: 'Suavidad',
  bgConnected: 'Solo el fondo conectado con los bordes (conserva un plato blanco sobre fondo blanco)',
  bgRefine: 'Ajustar',
  bgRefineBrush: 'Pincel de ajuste',
  bgKeep: 'Conservar',
  bgRemoveStroke: 'Quitar',
  bgRefineHint: 'Pinte para conservar o quitar zonas; Alt cambia entre las dos',
  bgEdge: 'Borde',
  bgFeather: 'Difuminado',
  bgShift: 'Mover el borde',
  bgDecontaminate: 'Descontaminar',
  bgView: 'Mostrar',
  bgViewChecker: 'Cuadrícula',
  bgViewWhite: 'Sobre blanco',
  bgViewBlack: 'Sobre negro',
  bgViewMask: 'Máscara',
  bgViewMatte: 'Mate',
  bgFill: 'Relleno',
  bgTransparent: 'Transparente',
  bgWhite: 'Blanco',
  bgColor: 'Color de relleno',
  bgShadow: 'Sombra',
  bgShadowBlur: 'Suavidad de la sombra',
  bgShadowOffset: 'Desplazamiento de la sombra',
  // M10
  vertical: 'Perspectiva vertical',
  horizontal: 'Perspectiva horizontal',
  panelLut: 'LUT',
  lutImport: 'Importar .cube…',
  lutNone: 'Ninguna',
  lutIntensity: 'Intensidad',
  lutDelete: 'Quitar esta LUT',
  lutError: 'No se pudo leer {name}: {reason}',
  importXmp: 'Importar .xmp de Lightroom…',
  xmpReportTitle: 'Se importó "{name}"',
  xmpApprox:
    'Las escalas de Lightroom no son las nuestras, así que los valores se aproximan. Revise el resultado.',
  xmpMapped: 'Aplicado ({n}):',
  xmpIgnored: 'No aplicado ({n}):',
  foodHint: 'Puntos de partida para fotos de menú; ajústelos a su gusto.',
  metadataButton: 'Metadatos…',
  metadataTitle: 'Metadatos que se escriben en las exportaciones',
  metaArtist: 'Autor',
  metaCopyright: 'Derechos de autor',
  metaEmail: 'Correo electrónico',
  metaWebsite: 'Sitio web',
  metaHint:
    'Se aplican según cada ajuste de exportación (conservar todo, quitar GPS, solo derechos, quitar todo).',
  save: 'Guardar',
  contactSheet: 'Hoja de contactos (PDF)',
  contactPaper: 'Papel',
  contactA4: 'A4',
  contactLetter: 'Carta',
  contactClient: 'Cliente',
  contactEvent: 'Evento',
  contactPage: 'Página {n} de {total}',
  contactPhotos: '{n} fotos',
  // M11a effects
  panelEffects: 'Efectos',
  vignette: 'Viñeta',
  vignetteAmount: 'Cantidad de viñeta',
  vignetteMidpoint: 'Punto medio',
  vignetteFeather: 'Difuminado',
  grain: 'Grano',
  grainAmount: 'Cantidad de grano',
  grainSize: 'Tamaño del grano',
  splitTone: 'Virado',
  stShadowHue: 'Tono de sombras',
  stShadowSat: 'Saturación de sombras',
  stHighlightHue: 'Tono de luces',
  stHighlightSat: 'Saturación de luces',
  stBalance: 'Equilibrio',
  // M11a simple mode
  proMode: 'Modo pro',
  simpleOpen: 'Abrir foto',
  simpleOpenFolder: 'o abrir una carpeta',
  stepOpen: 'Abrir',
  stepClean: 'Limpiar',
  stepFilter: 'Filtros',
  stepBackground: 'Fondo',
  stepSave: 'Guardar',
  strength: 'Intensidad',
  undoBig: 'Deshacer',
  startOver: 'Empezar de nuevo',
  holdOriginal: 'Mantenga para ver el original',
  clFixLighting: 'Arreglar luz',
  clFixColors: 'Arreglar colores',
  clBrighten: 'Aclarar',
  clTameSky: 'Bajar brillos',
  clCleanPlate: 'Limpiar plato',
  clSharpen: 'Más nítida',
  clReduceGrain: 'Quitar grano',
  clStraighten: 'Enderezar',
  clRemoveSpots: 'Quitar manchas',
  clCropFor: 'Recortar para…',
  clRemoveBackground: 'Quitar fondo',
  clNothing: 'No hay nada que arreglar aquí',
  clNoLine: 'No se encontró una línea recta',
  clSpotsHint: 'Toque cada mancha para quitarla',
  clCropHint: 'Arrastre la foto para ubicarla dentro del marco',
  cropSquare: 'Cuadrado (Instagram)',
  cropPortrait: 'Vertical 4:5',
  cropStory: 'Historia 9:16',
  cropMenu: 'Menú 3:2',
  fgFood: 'Comida',
  fgEveryday: 'Diario',
  fgMood: 'Ambiente',
  fgPeople: 'Personas',
  fgBw: 'Blanco y negro',
  noFilter: 'Sin filtro',
  bgTransparent2: 'Transparente',
  saveInstagram: 'Instagram',
  saveWhatsapp: 'WhatsApp',
  saveMenu: 'Menú',
  saveDelivery: 'App de delivery',
  savePng: 'Sin fondo (PNG)',
  wsPhotos: 'Fotos',
  wsDesign: 'Anuncios',
  workspace: 'Espacio de trabajo',
  designDocName: 'Nombre del documento',
  designNewOrOpen: 'Nuevo / abrir…',
  designSaved: 'Guardado',
  designSaving: 'Guardando…',
  designSaveFailed: 'No se pudo guardar',
  designUnsaved: 'Sin guardar',
  designSave: 'Guardar',
  designTools: 'Herramientas',
  designHintNone: 'Elija una herramienta a la izquierda.',
  dockEmpty: 'Seleccione algo para ver aquí sus ajustes.',
  designNewDoc: 'Diseño nuevo',
  designUntitled: 'Sin título',
  designMine: 'Sus diseños',
  designNone: 'Todavía no hay diseños.',
  historyOpen: 'Abrir',
  dockProperties: 'Propiedades',
  dockLayers: 'Capas',
  dockAppearance: 'Apariencia',
  dockSwatches: 'Muestras',
  dockType: 'Carácter y párrafo',
  dockArrange: 'Alinear y transformar',
  dockArtboards: 'Mesas de trabajo',
  dockSymbols: 'Símbolos',
  dockMenu: 'Menú',
  dockHistory: 'Historial',
  cmdAdd: 'Añadir',
  cmdDelete: 'Eliminar',
  cmdEdit: 'Editar',
  cmdTransform: 'Transformar',
  cmdRename: 'Cambiar nombre',
  cmdAddLayer: 'Capa nueva',
  cmdLayer: 'Capa',
  cmdDeleteLayer: 'Eliminar capa',
  cmdAddArtboard: 'Mesa de trabajo nueva',
  cmdArtboard: 'Mesa de trabajo',
  cmdDeleteArtboard: 'Eliminar mesa de trabajo',
  toolSelect: 'Selección',
  toolDirect: 'Selección directa',
  toolLasso: 'Lazo',
  toolPen: 'Pluma',
  toolCurvature: 'Curvatura',
  toolPencil: 'Lápiz',
  toolAddAnchor: 'Añadir punto de ancla',
  toolDeleteAnchor: 'Eliminar punto de ancla',
  toolConvertAnchor: 'Convertir punto de ancla',
  toolScissors: 'Tijeras',
  toolKnife: 'Cuchilla',
  toolRect: 'Rectángulo',
  toolEllipse: 'Elipse',
  toolPolygon: 'Polígono',
  toolStar: 'Estrella',
  toolLine: 'Segmento de línea',
  toolType: 'Texto',
  toolAreaType: 'Texto de área',
  toolPathType: 'Texto en trazado',
  toolRotate: 'Rotar',
  toolReflect: 'Reflejo',
  toolScale: 'Escala',
  toolShear: 'Distorsionar',
  toolEyedropper: 'Cuentagotas',
  toolGradient: 'Degradado',
  toolArtboard: 'Mesa de trabajo',
  toolHand: 'Mano',
  toolZoom: 'Lupa',
  hintSelect:
    'Haga clic para seleccionar y arrastre para mover; arrastre un tirador para escalar o fuera de una esquina para rotar.',
  hintDirect: 'Haga clic en un punto de ancla o un tirador para editarlo.',
  hintLasso: 'Arrastre alrededor de los puntos de ancla para seleccionarlos.',
  hintPen: 'Haga clic para esquinas y arrastre para curvas; haga clic en el primer punto para cerrar.',
  hintCurvature: 'Haga clic en puntos; la curva pasa por ellos.',
  hintPencil: 'Arrastre para dibujar a mano alzada.',
  hintAddAnchor: 'Haga clic en un trazado para añadir un punto.',
  hintDeleteAnchor: 'Haga clic en un punto para quitarlo.',
  hintConvertAnchor: 'Haga clic en un punto para hacerlo esquina; arrastre para suavizarlo.',
  hintScissors: 'Haga clic en un trazado para cortarlo ahí.',
  hintKnife: 'Arrastre sobre las formas para cortarlas.',
  hintRect: 'Arrastre para dibujar; Mayús para un cuadrado.',
  hintEllipse: 'Arrastre para dibujar; Mayús para un círculo.',
  hintPolygon: 'Arrastre desde el centro.',
  hintStar: 'Arrastre desde el centro.',
  hintLine: 'Arrastre para dibujar; Mayús para pasos de 45°.',
  hintType: 'Haga clic para escribir; arrastre para crear un cuadro de texto.',
  hintAreaType: 'Haga clic en una forma cerrada para escribir dentro.',
  hintPathType: 'Haga clic en un trazado para escribir a lo largo.',
  hintRotate: 'Arrastre para rotar la selección.',
  hintReflect: 'Haga clic para reflejar la selección.',
  hintScale: 'Arrastre para escalar la selección.',
  hintShear: 'Arrastre para inclinar la selección.',
  hintEyedropper: 'Haga clic en un objeto para copiar su apariencia.',
  hintGradient: 'Arrastre sobre la selección para ajustar el degradado.',
  hintArtboard: 'Arrastre para crear o mover mesas de trabajo.',
  hintHand: 'Arrastre para desplazarse (o mantenga la barra espaciadora con cualquier herramienta).',
  hintZoom: 'Haga clic para acercar y Alt+clic para alejar.',
  kindPath: 'Trazado',
  kindShape: 'Forma',
  kindText: 'Texto',
  kindImage: 'Imagen',
  kindGroup: 'Grupo',
  kindSymbol: 'Símbolo',
  layerN: 'Capa {n}',
  newLayer: 'Capa nueva',
  deleteLayer: 'Eliminar capa',
  showHide: 'Mostrar / ocultar',
  lockUnlock: 'Bloquear / desbloquear',
  layerName: 'Nombre de la capa',
  objectName: 'Nombre del objeto',
  targetIndicator: 'Contiene objetos seleccionados',
  moreObjects: '… y {n} objetos más',
  refPoint: 'Punto de referencia',
  width: 'Ancho',
  height: 'Alto',
  rotation: 'Rotación °',
  shear: 'Distorsión °',
  unitsAre: 'Unidades: {unit}',
  units: 'Unidades',
  cmdUnits: 'Unidades',
  cmdVisibility: 'Mostrar / ocultar',
  cmdLock: 'Bloquear',
  cmdDuplicate: 'Duplicar',
  cmdGroup: 'Agrupar',
  cmdUngroup: 'Desagrupar',
  cmdArrange: 'Organizar',
  cmdMove: 'Mover',
  alignCenter: 'Centro',
  alignInside: 'Interior',
  alignOutside: 'Exterior',
  arrowNone: 'Sin flecha',
  arrowTriangle: 'Triángulo',
  arrowOpen: 'Abierta',
  arrowCircle: 'Círculo',
  arrowSquare: 'Cuadrado',
  arrowBar: 'Barra',
  arrowStart: 'Punta inicial',
  arrowEnd: 'Punta final',
  arrows: 'Flechas',
  blend: 'Modo de fusión',
  blendNormal: 'Normal',
  blendMultiply: 'Multiplicar',
  blendScreen: 'Trama',
  blendOverlay: 'Superponer',
  blendDarken: 'Oscurecer',
  blendLighten: 'Aclarar',
  blendColorDodge: 'Sobreexponer color',
  blendColorBurn: 'Subexponer color',
  blendHardLight: 'Luz fuerte',
  blendSoftLight: 'Luz suave',
  blendDifference: 'Diferencia',
  blendExclusion: 'Exclusión',
  blendHue: 'Tono',
  blendSaturation: 'Saturación',
  blendColor: 'Color',
  blendLuminosity: 'Luminosidad',
  capButt: 'Extremo recto',
  capRound: 'Extremo redondo',
  capSquare: 'Extremo proyectado',
  joinMiter: 'Unión en ángulo',
  joinRound: 'Unión redonda',
  joinBevel: 'Unión biselada',
  cmykApprox: 'CMYK aproximado en pantalla: los valores que escribe se exportan exactos.',
  color: 'Color',
  colorMode: 'Modo de color',
  dashOffset: 'Desplazamiento del guion',
  dashes: 'Guiones',
  defaultFillStroke: 'Relleno y trazo por defecto',
  deleteSwatch: 'Eliminar muestra',
  expandShape: 'Expandir (convertir en trazado editable)',
  fill: 'Relleno',
  fillBox: 'Relleno',
  strokeBox: 'Trazo',
  fills: 'Rellenos',
  globalSwatch: 'global',
  hex: 'Hex',
  hue: 'Tono',
  innerRadius: 'Radio interior',
  outerRadius: 'Radio exterior',
  miterLimit: 'Límite de ángulo',
  newSwatch: 'Muestra nueva',
  noneColor: 'Ninguno',
  objectLook: 'Objeto',
  points: 'Puntas',
  radius: 'Radio',
  radiusX: 'Radio horizontal',
  radiusY: 'Radio vertical',
  radius_tl: 'Esquina superior izquierda',
  radius_tr: 'Esquina superior derecha',
  radius_br: 'Esquina inferior derecha',
  radius_bl: 'Esquina inferior izquierda',
  remove: 'Quitar',
  shapeOptions: 'Forma',
  sides: 'Lados',
  stroke: 'Trazo',
  strokeAlign: 'Posición del trazo',
  strokeCap: 'Extremo',
  strokeJoin: 'Unión',
  strokeWidth: 'Grosor',
  strokes: 'Trazos',
  swapFillStroke: 'Intercambiar relleno y trazo',
  swatchN: 'Muestra {n}',
  swatchName: 'Nombre de la muestra',
  cmdAppearance: 'Apariencia',
  cmdShape: 'Forma',
  cmdExpand: 'Expandir',
  cmdSwatch: 'Muestra',
  cmdSwatchDelete: 'Eliminar muestra',
  cmdColorMode: 'Modo de color',
  pathOps: 'Trazado',
  pathJoin: 'Unir',
  pathAverage: 'Promediar',
  pathCompound: 'Crear trazado compuesto',
  pathRelease: 'Liberar trazado compuesto',
  pathReverse: 'Invertir dirección',
  pathSimplify: 'Simplificar con tolerancia de',
  apply: 'Aplicar',
  cmdEditPath: 'Editar trazado',
  cmdScissors: 'Cortar trazado',
  cmdKnife: 'Cuchilla',
  cmdCompound: 'Trazado compuesto',
  cmdReleaseCompound: 'Liberar trazado compuesto',
  cmdGuide: 'Guía',
  cmdGuideDelete: 'Eliminar guía',
  alLeft: 'Alinear bordes izquierdos',
  alHCenter: 'Alinear centros horizontales',
  alRight: 'Alinear bordes derechos',
  alTop: 'Alinear bordes superiores',
  alVCenter: 'Alinear centros verticales',
  alBottom: 'Alinear bordes inferiores',
  diLeft: 'Distribuir bordes izquierdos',
  diHCenter: 'Distribuir centros horizontales',
  diRight: 'Distribuir bordes derechos',
  diTop: 'Distribuir bordes superiores',
  diVCenter: 'Distribuir centros verticales',
  diBottom: 'Distribuir bordes inferiores',
  diHSpace: 'Espaciado horizontal igual',
  diVSpace: 'Espaciado vertical igual',
  alignTo: 'Alinear a',
  alignToSelection: 'Selección',
  alignToKey: 'Objeto clave',
  alignToArtboard: 'Mesa de trabajo',
  keyHint: 'Haga clic otra vez en un objeto de la selección para convertirlo en objeto clave.',
  distribute: 'Distribuir',
  spacing: 'Espaciado',
  auto: 'Automático',
  viewMenu: 'Ver',
  snapOn: 'Ajustar',
  snapGrid: 'Ajustar a la cuadrícula',
  snapPixel: 'Ajustar a píxeles',
  smartGuides: 'Guías inteligentes',
  showGrid: 'Mostrar cuadrícula',
  showGuides: 'Mostrar guías',
  foodOriginals: 'Originales',
  foodSecFix: 'Arreglar la luz',
  foodSecDish: 'Por platillo',
  foodSecStyle: 'Estilos',
  foodSecMenu: 'Menú y delivery',
  bgFailedSimple: 'No se pudo quitar el fondo de esta foto. Intente de nuevo.',
  errUnsupported: 'este tipo de archivo no se puede abrir',
  errCorrupt: 'el archivo está dañado o incompleto',
  errHeic: 'las fotos HEIC no se pueden abrir en este navegador',
  errZipTooLarge: 'el zip pasaría de 3,5 GB. Exporte a una carpeta',
  errGpuReset: 'la tarjeta gráfica se reinició. Intente de nuevo',
  errWorker: 'una parte de la aplicación no cargó. Recargue la página',
  errNotXmp: 'no es un ajuste preestablecido de Lightroom o Camera Raw',
  errRefused: 'ese nombre es de una foto original, así que no se escribió',
  errGeneric: 'algo salió mal. Intente de nuevo',
  xmpAbsTemp: 'la temperatura absoluta (Kelvin) se ignora con JPEG aquí; use IncrementalTemperature',
  xmpAbsTint: 'el matiz absoluto se ignora; use IncrementalTint',
  xmpWbMode: 'el modo de balance de blancos no se importa',
  xmpNoTexture: 'no hay control de textura',
  xmpNoClarity: 'no hay control de claridad',
  xmpNoDehaze: 'no hay control para quitar neblina',
  xmpNoVignette: 'la viñeta no se importa',
  xmpNoGrain: 'el grano no se importa',
  xmpNoControl: 'no hay un control equivalente',
  xmpNotNumber: 'no es un número: "{raw}"',
  xmpPoints: '{n} puntos',
  saveOriginal: 'Tamaño original',
  saved: 'Se guardó {name}',
  saveFailed: 'No se pudo guardar: {reason}',
  // M11b
  about: 'Acerca de',
  aboutTitle: 'Acerca de EAT Photo Booth',
  aboutText:
    'Un estudio gratuito y sin conexión para fotos de comida, estilo y anuncios. Todo funciona en esta computadora y los originales nunca se modifican. Quitar fondo y Agrandar usan modelos pequeños guardados con la app. Las fotos salen de esta computadora solo si usted guarda su propia clave de IA y presiona un botón de IA.',
  aboutVersion: 'Versión {v}',
  aboutModels: 'Modelos de IA (en esta computadora)',
  aboutLicenses: 'Software de código abierto incluido ({n} paquetes)',
  aboutLgpl: 'libheif-js (LGPL-3.0) se carga como un módulo WebAssembly aparte, solo para leer fotos HEIC.',
  cheatTitle: 'Atajos de teclado',
  kPrevNext: 'Foto anterior / siguiente',
  kRate: 'Calificación con estrellas',
  kReject: 'Descartar',
  kCull: 'Vista de selección',
  kBefore: 'Antes / después (toque o mantenga)',
  kSplit: 'Vista dividida antes/después',
  kClipping: 'Aviso de recorte de luces y sombras',
  kZoom: 'Zoom ajustado / 100 %',
  kCrop: 'Herramienta de recorte',
  kMaskOverlay: 'Mostrar la máscara',
  kRemoveBg: 'Quitar fondo',
  kBgView: 'Vista del fondo (cuadrícula, blanco, negro, máscara, mate)',
  kCopy: 'Copiar ajustes (Mayús: elegir grupos)',
  kPaste: 'Pegar ajustes en la selección (Mayús: elegir grupos)',
  kUndoRedo: 'Deshacer / rehacer',
  kExport: 'Exportar',
  kAlt: 'Pasos finos en deslizadores; borrar con pinceles; origen de corrección',
  kPan: 'Mantenga y arrastre para desplazarse al 100 %',
  kEscEnter: 'Salir de una herramienta o de la vista de selección',
  kCheat: 'Esta lista',
  helpTopic: 'Ayuda: {topic}',
  makeBigger: 'Agrandar',
  makeBigger2: '2× más grande',
  makeBigger4: '4× más grande',
  makeBiggerOff: 'Tamaño original',
  makeBiggerSize: '{w} × {h} px → {W} × {H} px (agrandada)',
  makeBiggerTooLarge: 'Esta foto ya tiene el tamaño máximo (24 MP).',
  makeBiggerRunning: 'Agrandando… {done} de {total}',
  makeBiggerDone: 'Agrandada a {w} × {h} px',
  makeBiggerFailed: 'No se pudo agrandar esta foto: {reason}',
  panelUpscale: 'Ampliación',
  upscaleFactor: 'Tamaño',
  upscaleModel: 'Modelo',
  upscaleModelGeneral: 'General (rápido, incluido)',
  upscaleModelPlus: 'Foto x4plus (más nítido, más lento)',
  upscaleModelMissing: 'No instalado (npm run fetch-models -- esrgan-plus)',
  upscaleStrength: 'Intensidad',
  upscaleStrengthHint: 'Bajo conserva la textura de la foto; alto limpia más ruido y bloques de JPEG.',
  upscaleApply: 'Aplicar',
  upscaleNote: 'Los píxeles agrandados los crea un modelo de IA en esta computadora. No se sube nada.',
  aboutUpscaleModels: 'Modelos de ampliación',
  dockAd: 'Anuncio',
  cmdApplyBrand: 'Aplicar marca',
  cmdEditAd: 'Editar texto del anuncio',
  cmdFillPhoto: 'Colocar foto',
  makeAd: 'Crear anuncio',
  makeAdHint: 'Ponga esta foto en un anuncio listo con su logo y precios.',
  adPickTemplate: 'Elija una plantilla',
  adMyBrand: 'Mi marca',
  adBackToAd: 'Volver a mi anuncio',
  adWithPhoto: 'Usará la foto {name}.',
  adNoPhoto: 'No hay una foto abierta: el espacio de la foto queda vacío hasta que agregue una.',
  adWorking: 'Trabajando…',
  adTemplates: 'Plantillas',
  adTemplatesStart: 'Crear un anuncio con una plantilla',
  adPreparingPhoto: 'Preparando la foto…',
  adNotAnAd: 'Este diseño no es una plantilla de anuncio. Elija una plantilla para ver el formulario.',
  adText: 'Texto',
  adDishName: 'Nombre del plato',
  adDescription: 'Descripción',
  adHeadline: 'Titular',
  adTagline: 'Línea corta',
  adHumour: 'Frase con humor (va al titular; puede editarla)',
  adHumourGeneral: 'Cualquier comida',
  adHumourFast: 'Hamburguesas y comida rápida',
  adLocation: 'Línea de ubicación',
  adLocationHint: 'De Mi marca: {v}',
  adPhotoSecond: 'Segunda foto (el otro plato)',
  adSpanish: 'español',
  adEnglish: 'inglés',
  adPrice: 'Precio',
  adOldPrice: 'Antes (tachado)',
  adPriceShows: 'Se ve así: {p}',
  adMenuItems: 'Platos del menú',
  adPhoto: 'Foto',
  adUseCurrentPhoto: 'Usar la foto que estoy editando',
  adChoosePhoto: 'O elija otra foto',
  adPhotoFromFile: 'Foto desde un archivo…',
  adPhotoZoom: 'Acercar',
  adPhotoLeftRight: 'Izquierda / derecha',
  adPhotoUpDown: 'Arriba / abajo',
  adPhotoWhole: 'Mostrar la foto completa (sin recortar)',
  adSave: 'Guardar',
  adPngSize: 'Tamaño del PNG',
  adSavePng: 'Guardar PNG',
  adSavePdf: 'Guardar PDF (para imprimir)',
  adTextObject: 'Texto seleccionado',
  adTextBound: 'Muestra el campo del anuncio "{field}" ({lang}); cámbielo en el formulario de abajo.',
  adTextContent: 'Contenido',
  adFont: 'Fuente',
  adWeight: 'Grosor',
  adSize: 'Tamaño',
  adColor: 'Color de texto',
  adAlign: 'Alineación',
  adLines: 'Máx. de líneas',
  adTracking: 'Espaciado',
  adLeading: 'Interlineado',
  adCaps: 'TODO EN MAYÚSCULAS',
  adShrunk: 'Reducido a {size} para caber en su caja.',
  adOverflow: 'El texto no cabe ni en el tamaño más pequeño; termina en "…".',
  alignLeftShort: 'Izquierda',
  alignCenterShort: 'Centro',
  alignRightShort: 'Derecha',
  brandIntro: 'Configúrelo una vez: todas las plantillas usan su nombre, logo, colores y fuentes.',
  brandName: 'Nombre del restaurante',
  brandContact: 'Línea de contacto (teléfono, dirección o web)',
  brandContactHint: 'WhatsApp 5555-0000 · 4a Calle 1-23 (ejemplo)',
  brandLocation: 'Línea de ubicación (pueblo, zona)',
  brandLocationHint: 'Zona 10 · Ciudad de Guatemala (ejemplo)',
  brandLogo: 'Logo (un PNG con fondo transparente se ve mejor)',
  brandLogoRemove: 'Quitar logo',
  brandColors: 'Colores de la marca',
  brandPrimary: 'Principal',
  brandSecondary: 'Secundario',
  brandAccent: 'Acento',
  brandBackground: 'Fondo',
  brandText: 'Texto',
  brandHeadingFont: 'Fuente de títulos',
  brandBodyFont: 'Fuente de texto',
  brandCurrency: 'Símbolo de moneda',
  brandDecimals: 'Decimales',
  brandSymbolAfter: 'Símbolo después del número',
  brandSave: 'Guardar mi marca',
  brandDefaults: 'Restablecer valores predeterminados',
  aiButton: 'IA',
  aiSettings: 'IA con su propia clave',
  aiIntro:
    'Opcional. Todo en la aplicación funciona sin clave. Con una clave de OpenAI o Google obtiene arreglo inteligente, textos de anuncios en inglés y español y retoque con IA.',
  aiKey: 'Clave de API',
  aiKeyPlaceholder: 'Pegue su clave aquí',
  aiKeyStored:
    'La clave se guarda solo en este navegador. Nunca se registra ni se escribe en sus fotos, diseños o exportaciones.',
  aiModels: 'Nombres de modelos (avanzado)',
  aiModelVision: 'Texto y arreglo inteligente:',
  aiModelImage: 'Imágenes:',
  aiPrivacy:
    'Una foto se envía al proveedor solo cuando usted presiona un botón de IA, directamente desde este navegador. Aplican los precios y condiciones del proveedor.',
  aiSave: 'Guardar',
  aiRemoveKey: 'Quitar clave',
  aiKeySet: 'Clave guardada: {provider} ({key})',
  aiNoKey: 'Sin clave: los botones de IA están ocultos y no se envía nada.',
  aiSmartFix: 'Arreglo inteligente (IA)',
  aiTouchUp: 'Retoque con IA',
  aiUpscale: 'Ampliar con IA',
  aiSendsPhoto: 'Estos botones envían una copia pequeña de la foto a su proveedor de IA.',
  aiFailed: 'La IA no funcionó: {reason}',
  aiCompareTitle: 'Resultado de IA junto al original',
  aiOriginal: 'Original (su foto)',
  aiGenerated: 'Generado por IA',
  aiDeliveryNote:
    'Las apps de delivery exigen fotos del plato real. Una imagen hecha con IA puede mostrar cosas que no están en el plato; úsela con cuidado y nunca en lugar de una foto real donde se exige una.',
  aiSaveCopy: 'Guardar la versión de IA como archivo nuevo',
  aiWriteText: 'Escribir el texto con IA',
  panelAi: 'IA (su clave)',
  wsPlating: 'Emplatado',
  platingGuide: 'Guía de emplatado',
  platingTitle: 'Guías de emplatado y foto',
  platingIntro: 'Imprima una tarjeta para la cocina: cómo emplatar el plato y cómo fotografiarlo.',
  platingMine: 'Mis tarjetas',
  platingBuiltIn: 'Tarjetas listas',
  platingNoneYet: 'Ninguna todavía: duplique una tarjeta para hacer la suya.',
  platingLanguage: 'Idioma de la tarjeta',
  platingBoth: 'Ambos (español / inglés)',
  platingSavePdf: 'Guardar PDF (para imprimir)',
  platingDuplicate: 'Duplicar para hacer la mía',
  platingCopy: 'Hacer una copia',
  platingDelete: 'Eliminar esta tarjeta',
  platingExportFile: 'Guardar archivo de tarjeta (para compartir)',
  platingImportFile: 'Abrir un archivo de tarjeta',
  platingCardName: 'Nombre de la tarjeta (su plato)',
  platingPlate: 'Plato',
  platingAngle: 'Ángulo de la cámara',
  platingElements: 'En el plato',
  platingDragHint: 'Arrastre las figuras en el dibujo para moverlas.',
  platingRemove: 'Quitar',
  platingRotate: 'Girar',
  platingAddElement: 'Agregar un elemento',
  platingLight: 'Consejo de luz',
  platingSteps: 'Pasos',
  platingStepsHint: 'Un paso por línea.',
  platingPhoto: 'Foto de referencia',
  platingPhotoRemove: 'Quitar foto',
  aboutFonts: 'Fuentes (para anuncios)',
  themeDark: 'Tema oscuro',
  themeLight: 'Tema claro',
  appShort: 'Photo Booth',
  helpPages: 'Páginas de ayuda',
  stepOf: 'Paso {n} de {total}',
  stepBack: 'Atrás',
  stepNext: 'Siguiente',
  saveBig: 'Guardar',
  filtersSampleHint: 'Abra una foto para probar estos filtros',
  noticeDismiss: 'Cerrar',
  moreOptions: 'Más',
};
